import { resolveDirective as _resolveDirective, isVNode as _isVNode, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import "core-js/modules/es.array.push.js";
import { defineComponent, reactive, computed, ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
export default defineComponent({
  setup() {
    const currentRouter = useRoute();
    const store = useStore();
    const menuData = computed(() => store.state.app);
    const menuCollectList = menuData.value.menuObject;
    const plaformType = menuData.value.plaformType;
    const treeMenu = reactive(computed(() => {
      const opt = store.state.app.menuObject;
      return opt;
    }));
    const silderMainName = reactive(computed(() => {
      const opt = store.state.app.selectList.find(it => store.state.app.menuObject.plaformType === it.value);
      if (opt) {
        return opt;
      }
      return {};
    }));
    const treeFilter = (tree, func, childrenkey) => {
      // 使用map复制一下节点，避免修改到原树
      return tree.map(node => ({
        ...node
      })).map(node => {
        if (node[childrenkey || 'children']) {
          node[childrenkey || 'children'] = node[childrenkey || 'children'] && treeFilter(node[childrenkey || 'children'], func);
        }
        return func(node) || node[childrenkey || 'children'] && node[childrenkey || 'children'].length;
      });
    };
    const menuItemList = function deep(props, history, only) {
      // 菜单列表Dom渲染
      const router = useRouter();
      if (props && Array.isArray(props) && props.length) {
        return props.map((item, index) => {
          if (item) {
            if (item.children && Array.isArray(item.children) && item.children.length) {
              let _slot;
              const str = item && item.title ? item.title : '';
              return _createVNode(_resolveComponent("el-sub-menu"), {
                "key": item.path || item.menuKey,
                "index": item.path || item.menuKey
              }, {
                default: () => [_createVNode(_resolveComponent("el-menu-item-group"), null, _isSlot(_slot = deep(item.children, history, true)) ? _slot : {
                  default: () => [_slot]
                })],
                title: () => {
                  return _createVNode("div", null, [_createVNode(_resolveComponent("el-icon"), null, {
                    default: () => [_createVNode(_resolveComponent("location"), null, null)]
                  }), _createVNode("span", null, [str])]);
                }
              });
            }
            if (item.title) {
              const str = item.title || item.meta.title;
              const onlyState = only || false;
              return !item.hideMenu || item.hideMenu === 1 ? _createVNode(_resolveComponent("el-menu-item"), {
                "key": item.path || item.menuKey,
                "index": item.path || item.menuKey,
                "onClick": e => {
                  if (/^[/]?http[s]?:\/\/.*/.test(item.path)) {
                    window.open(item.path, '_blank');
                  } else {
                    router.push(item.path);
                  }
                }
              }, _isSlot(str) ? str : {
                default: () => [str]
              }) : _createVNode("div", null, null);
            } else {
              return _createVNode("div", null, null);
            }
          }
          return _createVNode("div", null, null);
        });
      }
    };
    return {
      currentRouter,
      silderMainName,
      menuItemList,
      menuCollectList,
      plaformType,
      treeMenu
    };
  },
  render() {
    let _slot2;
    return _createVNode(_resolveComponent("el-aside"), {
      "class": "aside-layout",
      "width": "200px"
    }, {
      default: () => [_createVNode("div", {
        "class": "platform_title"
      }, [_createVNode("span", null, [this.silderMainName.label])]), _createVNode(_resolveComponent("el-scrollbar"), {
        "class": "aside_scroller"
      }, {
        default: () => [_createVNode(_resolveComponent("el-menu"), {
          "class": "el-menu-vertical",
          "show-timeout": "200",
          "collapse": false,
          "uniqueOpened": true,
          "mode": "vertical",
          "textColor": "#191919",
          "activeTextColor": "#1843d1e0",
          "defaultActive": this.currentRouter.path
        }, _isSlot(_slot2 = this.menuItemList(this.treeMenu.treeMenuList)) ? _slot2 : {
          default: () => [_slot2]
        })]
      })]
    });
  }
});